import { DATE_HINTS, TimePeriod } from "../utils/date-hints";


export const dateTransform = (dateType: TimePeriod, key: 'start' | 'end') => {
    const updatedTime = DATE_HINTS.find(item => item.dateAlias === dateType);
    return updatedTime?.interval[key] as Date;
}